import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

import 'es7-object-polyfill'
import 'polyfill-array-includes'

import { stations } from '../global-styles'
import { getTestDisturbanceParam } from '../../other/mockData'

import MessageBanner from '../../Components/MessageBanner/MessageBanner'
import Departures from '../Departures/Departures'
import FailureState from '../../States/Failure/FailureState'
import CriticalState from '../../States/Critical/CriticalState'

const apiURL = process.env.REACT_APP_DEPARTURES_API_URL
const disturbanceUrls: { [key: string]: string } = {
    [stations.stockholm]: `${apiURL}/screen-disturbances/stockholm`,
    [stations.arlandaSouth]: `${apiURL}/screen-disturbances/arlanda-south`,
    [stations.arlandaNorth]: `${apiURL}/screen-disturbances/arlanda-north`,
}

// A PureComponent
const Disturbances = React.memo<{
    station: string
    count: number
}>(
    ({ station, count }) => {
        // Start Handle disturbance
        const [disturbanceRequest, setDisturbanceRequest] = useState<any>({})

        useEffect(() => {
            if (count === 0 && station) {
                fetch(`${disturbanceUrls[station]}${getTestDisturbanceParam()}`)
                    .then((response) => [response.status, response.json()])
                    .then(([status, data]) => {
                        if (typeof data !== 'number') {
                            data.then((d) => {
                                if (status === 200) {
                                    setDisturbanceRequest({ type: 'Success', data: d })
                                } else {
                                    setDisturbanceRequest({
                                        type: 'Failure',
                                        data: '[Error message 1]',
                                    })
                                }
                            }).catch((e) =>
                                setDisturbanceRequest({
                                    type: 'Failure',
                                    data: '[Error message 5]',
                                })
                            )
                        }
                    })
                    .catch((e) =>
                        setDisturbanceRequest({
                            type: 'Failure',
                            data: '[Error message 2]',
                        })
                    )
            }
        }, [station, count]) // Only re-run the effect if these values changes

        // END Handle disturbance

        let status = null
        let content = null
        const departureData = {
            station,
            count,
        }

        if (!station || !Object.values(stations).includes(station)) {
            console.warn('No station to show data from')
            content = <FailureState />
        } else if (disturbanceRequest.type === 'Failure') {
            // We know nothing, test if Departures knows something
            content = <Departures {...departureData} />
        } else if (disturbanceRequest.type === 'Success') {
            if (disturbanceRequest.data) {
                content = <Departures {...departureData} />

                if (disturbanceRequest.data.type === 'Eight') {
                    status = (
                        <MessageBanner
                            key={disturbanceRequest.data.value.en}
                            isError={true}
                            texts={[disturbanceRequest.data.value.en, disturbanceRequest.data.value.sv]}
                        />
                    )
                } else if (disturbanceRequest.data.type === 'Nine') {
                    content = (
                        <CriticalState
                            messageEn={disturbanceRequest.data.value.en}
                            messageSv={disturbanceRequest.data.value.sv}
                        />
                    )
                } else if (disturbanceRequest.data.type === 'Three') {
                    status = (
                        <MessageBanner
                            key={disturbanceRequest.data.value.en}
                            isError={false}
                            texts={[disturbanceRequest.data.value.en, disturbanceRequest.data.value.sv]}
                        />
                    )
                }
            } else {
                // We know nothing, test if Departures knows something
                content = <Departures {...departureData} />
            }
        }

        return (
            <DisturbancesWrapper>
                {status}
                {content}
            </DisturbancesWrapper>
        )
    },
    (prevProps, nextProps) => nextProps.count > 1 // Need both 0 and 1 for fetch effect to trigger
)

export default Disturbances

const DisturbancesWrapper = styled.div``
